import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78d39e18"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "back"
};
const _hoisted_2 = {
  class: "rule"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 选择所在地区 ");
const _hoisted_5 = {
  key: 0,
  class: "select-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-line-line"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-line-point"
}, null, -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow_icon"
}, null, -1));
const _hoisted_11 = {
  class: "scroll-view render-hide-scroll",
  "scroll-y": "true",
  "show-scrollbar": "false"
};
const _hoisted_12 = {
  class: "scroll-title"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  key: 0,
  class: "icon-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
    class: "close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
  })]), $data.swiper_length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.swiper_length, (select_item, select_index) => {
    return _openBlock(), _createElementBlock("div", {
      key: select_index,
      class: _normalizeClass(['select-item', {
        highlight: $data.swiper_index == select_index
      }]),
      onClick: $event => $options.selectedChangeAction(select_index)
    }, [_createElementVNode("div", {
      class: _normalizeClass(['time-line', {
        highlight: select_index < $data.selectedList.length,
        normal: select_index >= $data.selectedList.length
      }])
    }, _hoisted_9, 2), _createTextVNode(" " + _toDisplayString($data.selectedList.length > select_index ? $data.selectedList[select_index].name : $options.select_placeholer(select_index)) + " ", 1), _hoisted_10], 10, _hoisted_6);
  }), 128))])) : _createCommentVNode("", true), _createVNode(_component_van_swipe, {
    class: "swiper-view",
    "initial-swipe": $data.swiper_index,
    onChange: $options.swiperChangeAction,
    duration: 0,
    touchable: false,
    loop: false,
    ref: "mySwipe"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.swiper_length, (column_item, column_index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: column_index
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString($options.select_placeholer($data.swiper_index)), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.currentShowList, (row_item, row_index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(['item', {
              mark: $data.selectedList.length > column_index && row_item.id == $data.selectedList[column_index].id
            }]),
            key: row_index,
            onClick: $event => $options.selectAction(row_item, column_index)
          }, [_createTextVNode(_toDisplayString(row_item.name) + " ", 1), $data.selectedList.length > column_index && row_item.id == $data.selectedList[column_index].id ? (_openBlock(), _createElementBlock("text", _hoisted_14)) : _createCommentVNode("", true)], 10, _hoisted_13);
        }), 128))])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["initial-swipe", "onChange"])])]);
}